import { iconType } from 'app/common/ui-next/plain-icon'

const ORGS_SETTINGS_GENERAL = 'general' as const
const ORGS_SETTINGS_LIMITS = 'limits' as const
const ORGS_SETTINGS_REQUESTS = 'requests' as const
const ORGS_SETTINGS_SUBSIDIES = 'subsidies' as const
const ORGS_SETTINGS_DIET_FOOD = 'diet_food' as const
const ORGS_SETTINGS_REPORTS = 'reports' as const
const ORGS_SETTINGS_SELLPOINTS = 'sellpoints' as const
const ORGS_SETTINGS_CAFETERIA = 'cafeteria' as const

const sections = {
  ORGS_SETTINGS_GENERAL,
  ORGS_SETTINGS_LIMITS,
  ORGS_SETTINGS_REQUESTS,
  ORGS_SETTINGS_SUBSIDIES,
  ORGS_SETTINGS_DIET_FOOD,
  ORGS_SETTINGS_REPORTS,
  ORGS_SETTINGS_SELLPOINTS,
  ORGS_SETTINGS_CAFETERIA,
}

export type Section = (typeof sections)[keyof typeof sections]
export default sections

export const availableSections: Array<Section> = [
  sections.ORGS_SETTINGS_GENERAL,
  sections.ORGS_SETTINGS_LIMITS,
  sections.ORGS_SETTINGS_REQUESTS,
  sections.ORGS_SETTINGS_SUBSIDIES,
  sections.ORGS_SETTINGS_DIET_FOOD,
  sections.ORGS_SETTINGS_REPORTS,
  sections.ORGS_SETTINGS_SELLPOINTS,
  sections.ORGS_SETTINGS_CAFETERIA,
]

export const defaultSection = sections.ORGS_SETTINGS_GENERAL

export const sectionTitles: Record<Section, string> = {
  [sections.ORGS_SETTINGS_GENERAL]: 'Общие настройки',
  [sections.ORGS_SETTINGS_LIMITS]: 'Лимиты',
  [sections.ORGS_SETTINGS_REQUESTS]: 'Комплексное питание и\u00A0личные\u00A0продажи',
  [sections.ORGS_SETTINGS_SUBSIDIES]: 'Дотации',
  [sections.ORGS_SETTINGS_DIET_FOOD]: 'Диет. питание',
  [sections.ORGS_SETTINGS_REPORTS]: 'Отчеты',
  [sections.ORGS_SETTINGS_SELLPOINTS]: 'Точки продаж',
  [sections.ORGS_SETTINGS_CAFETERIA]: 'Место питания',
}

export const sectionIcons: Record<Section, string> = {
  [sections.ORGS_SETTINGS_GENERAL]: iconType.GENERAL_SETTINGS,
  [sections.ORGS_SETTINGS_LIMITS]: iconType.LIMITS,
  [sections.ORGS_SETTINGS_REQUESTS]: iconType.REQUESTS,
  [sections.ORGS_SETTINGS_SUBSIDIES]: iconType.SUBSIDIES,
  [sections.ORGS_SETTINGS_DIET_FOOD]: iconType.SUBSIDIES,
  [sections.ORGS_SETTINGS_REPORTS]: iconType.REPORTS,
  [sections.ORGS_SETTINGS_SELLPOINTS]: iconType.SELLPOINTS,
  [sections.ORGS_SETTINGS_CAFETERIA]: iconType.EATING_PLACE,
}
